const BUTTON_ASSETS = {
  signIn: {
    en: "/images/uae-pass/sign-in-en.png",
    ar: "/images/uae-pass/sign-in-ar.png",
  },
  signUp: {
    en: "/images/uae-pass/sign-up-en.png",
    ar: "/images/uae-pass/sign-up-ar.png",
  },
};

const BUTTON_LABELS = {
  signIn: {
    en: "Sign in with UAE PASS",
    ar: "تسجيل الدخول بالهوية الرقمية",
  },
  signUp: {
    en: "Sign up with UAE PASS",
    ar: "إنشاء الحساب بالهوية الرقمية",
  },
};

export default function UaePassButton({ flow, isArabic, onClick, disabled = false }) {
  const language = isArabic ? "ar" : "en";
  const asset = BUTTON_ASSETS[flow]?.[language];
  const label = BUTTON_LABELS[flow]?.[language];

  if (!asset || !label) {
    return null;
  }

  return (
    <button
      type="button"
      className="uae-pass-btn"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <img src={asset} alt="" aria-hidden="true" />
    </button>
  );
}
